











































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { exportToCSV, DatabaseHeader } from './admin/tables/database';
import gql from 'graphql-tag';
import _ from 'lodash';

import Plotly from 'src/misc/external/plotly';
import { Threshold } from '../../../common/project';

import * as PROJECT_THRESHOLDS_FRAGMENT_QUERY from 'src/graphql/ProjectThresholdsFragment.graphql';

@Component
export default class HumidityPlotWrapperObject extends Vue {
  $refs: {
    plotRef: any
  }

  layout: any = null;

  isZoomedAll = false;
  isZoomed = [
    false,
    false,
    false,
  ];

  zoomOneShapes = [];
  zoomAllShapes = [];
  thresholdAnnotations = [];

  rangeX = {
    // Since X is logarithmic, we have to take log of the value.
    //        Math.log10(1.8)      Math.log10(115.15)
    zoomed: [ 0.2552725051,        2.0625819842],
    //        Math.log10(0.742147) Math.log10(141.4813)
    full:   [-0.12951000281599928, 2.150699301885937],
  };

  rangeY = [];

  rangeAxisY = [
    {
      zoomed: [],
      full:   [],
    },
    {
      zoomed: [],
      full:   [],
    },
    {
      zoomed: [],
      full:   [],
    },
  ];

  rhIndexFocused = -1;
  numDataPoints = 0;

  weeks = [1, 2, 3, 5, 14, 27, 40, 53, 79, 105];
  years = ['Initial', '1 week', '2 weeks', '1 month', '3 months', '6 months', '9 months', '1 year', '1.5 years', '2 years'];

  thresholds: Threshold[] = _.cloneDeep(this.project.thresholds);
  updateThresholdsDebounced = _.debounce(this.updateThresholds, 500);
  isUpdatingThresholds = false;

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get project() {
    return this.$store.state.currentProject;
  }

  get appMenuMini() {
    return this.$store.state.appMenuMini;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }

  get lgAndUp() {
    return this.$vuetify.breakpoint.lgAndUp;
  }

  @Watch('boards', { deep: true })
  onBoardsChanged() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }

  @Watch('project.thresholds', { deep: true })
  onProjectThresholds() {
    // Wait until project thresholds are received.
    if (!_.isEqual(this.thresholds, this.project.thresholds) && !this.isUpdatingThresholds) {
      this.thresholds = _.cloneDeep(this.project.thresholds);
    }
  }

  @Watch('thresholds', { deep: true })
  onWatchThresholds() {
    // Update the result directly, but bounce the write to the database a bit.
    for (let board of this.boards.filter( board => board.visible && board.hasSimulationSuccessWithHumidityImpact() )) {
      board.thresholdResults = [];
      board.setThresholdResults(this.thresholds);
    }

    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();

    if (this.rhIndexFocused != -1)
      this.mouseOverRow(this.rhIndexFocused);

    this.updateThresholdsDebounced();
  }

  @Watch('appMenuMini')
  onAppMenuMiniChanged() {
    this.handleResizeDelayed();
  }

  @Watch('card', { deep: true })
  onCardChanged() {
    this.handleResizeDelayed();
  }

  @Watch('lgAndUp')
  onLgAndUpChanged() {
    this.handleResize();
  }

  getPlotlyIndex(i) {
    return i === 0 ? '' : String(i + 1);
  }

  rhValueToDescriptive(rh: string) {
    if (rh == '50%')
      return 'Lab. Standard';
    else if (rh == '<75%')
      return 'Normal';
    else if (rh == '>85%')
      return 'Demanding';
    else
      return rh;
  }

  weeksToDescriptive(weeks: number) {
    if (weeks <= 0) {
      return "0 days";
    } else if (weeks > 104) {
      return ">104 weeks";
    } else if (weeks < 4) {
      const rounded = Math.round(weeks * 7.0);
      return rounded + " day" + (rounded == 1 ? "" : "s");
    } else {
      const rounded = Math.round(weeks * 10) / 10;
      return rounded + " weeks";
    }
  }

  weeksToDisplayClass(weeks: number) {
    if (weeks <= 0) {
      return "error--text fade";
    } else if (weeks < 4) {
      const rounded = Math.round(weeks * 7.0);
      if (rounded == 0)
        return "error--text fade"
    } else if (weeks > 104) {
      return "info--text fade";
    }

    return '';
  }

  range(start, length, step = 1) {
    return Array.from({length}, (v, k) => k * step + start);
  }

  rhIndexToDataIndex(rhIndex) {
    // rhIndex is 0,2,4 or 4,2,0 (depending on if the plots are on top or next to eachother)
    // dataIndex is always 0,1,2
    if (this.$vuetify.breakpoint.lgAndUp)
      return rhIndex / 2;
    else
      return Math.abs(rhIndex - 4) / 2;
  }

  mouseOverRow(rhIndex) {
    // Since the data is stored row-wise, start at the current row (data index) and take the next number of data points.
    const rowIndicies = this.range(this.rhIndexToDataIndex(rhIndex) * this.numDataPoints, this.numDataPoints)

    Plotly.restyle(this.$refs.plotRef, { opacity: 0.2 }, );
    Plotly.restyle(this.$refs.plotRef, { opacity: 1.0 }, rowIndicies);

    for (let i of rowIndicies) {
      this.thresholdAnnotations[i].visible = true;
    }
    Plotly.relayout(this.$refs.plotRef, this.layout);
  }

  mouseOverColumn(boardIndex) {
    // Since the data is stored row-wise, start at first row and jump to the current column (board index).
    // Since there is 3 plots, take the next 3 data points with the step size of the number of data points.
    const columnIndicies = this.range(boardIndex, 3, this.numDataPoints);

    Plotly.restyle(this.$refs.plotRef, { opacity: 0.2 }, );
    Plotly.restyle(this.$refs.plotRef, { opacity: 1.0 }, columnIndicies);

    for (let i of columnIndicies) {
      this.thresholdAnnotations[i].visible = true;
    }
    Plotly.relayout(this.$refs.plotRef, this.layout);
  }

  mouseOverCell(boardIndex, rhIndex) {
    // Since the data is stored row-wise, start at the current row (data index) and jump to the column (board index).
    const cellIndex = this.rhIndexToDataIndex(rhIndex) * this.numDataPoints + boardIndex;

    Plotly.restyle(this.$refs.plotRef, { opacity: 0.2 }, );
    Plotly.restyle(this.$refs.plotRef, { opacity: 1.0 }, [cellIndex]);

    this.thresholdAnnotations[cellIndex].visible = true;
    Plotly.relayout(this.$refs.plotRef, this.layout);
  }

  mouseOverNone() {
    Plotly.restyle(this.$refs.plotRef, { opacity: 0.2 });

    // Show every threshold annotation when hovering the threshold header.
    for (const thresholdAnnotation of this.thresholdAnnotations) {
      thresholdAnnotation.visible = true;
    }
    Plotly.relayout(this.$refs.plotRef, this.layout);
  }

  mouseLeave() {
    Plotly.restyle(this.$refs.plotRef, { opacity: 1.0 });

    // Hide everything on mouse leave, unless the threshold input has focus.
    for (const thresholdAnnotation of this.thresholdAnnotations) {
      thresholdAnnotation.visible = false;
    }
    Plotly.relayout(this.$refs.plotRef, this.layout);

    if (this.rhIndexFocused != -1)
      this.onFocusThreshold(this.rhIndexFocused);
  }

  onFocusThreshold(rhIndex) {
    this.rhIndexFocused = rhIndex;
    this.mouseOverRow(rhIndex);
  }

  onBlurThreshold() {
    this.rhIndexFocused = -1;
    this.mouseLeave();
  }

  onExport() {
    this.exportHumidityPlots();
    this.exportThresholdTable();
  }

  exportHumidityPlots() {
    let headers: DatabaseHeader[] = [{
      text: "RH",
      value: "rh",
    },{
      text: "Name",
      value: "board",
    }];

    for (const week of this.weeks) {
      headers.push({
        text: String(week - 1),
        value: String(week - 1),
      });
    }

    let values = [];
    for (const [thresholdIndex, threshold] of this.thresholds.entries()) {
      for (const [boardIndex, board] of this.boards.filter( board => board.visible && board.hasSimulationSuccessWithHumidityImpact() ).entries()) {
        let row = {
          rh: threshold.RH_value,
          board: board.name,
        };

        const board_values = board.simulationResults[0].stacking_factors_result.RH_results[thresholdIndex].bct_values;
        for (const [weekIndex, week] of this.weeks.entries()) {
          row[String(week - 1)] = board_values[weekIndex];
        }
        values.push(row);
      }
    }

    exportToCSV('HumidityImpact-Plots', headers, values);
  }

  exportThresholdTable() {
    let headers: DatabaseHeader[] = [{
      text: "RH",
      value: "rh",
    },{
      text: "Threshold",
      value: "threshold",
      unit: "N",
    }];

    for (const [boardIndex, board] of this.boards.filter( board => board.visible && board.hasSimulationSuccessWithHumidityImpact() ).entries()) {
      headers.push({
        text: board.name,
        value: "weeks" + boardIndex,
        unit: "weeks",
      });
    }

    let values = [];
    for (const [thresholdIndex, threshold] of this.thresholds.entries()) {
      let row = {
        rh: threshold.RH_value,
        threshold: threshold.bct_value,
      };

      for (const [boardIndex, board] of this.boards.filter( board => board.visible && board.hasSimulationSuccessWithHumidityImpact() ).entries()) {
        row["weeks" + boardIndex] = board.thresholdResults[thresholdIndex].weeks;
      }
      values.push(row);
    }

    exportToCSV('HumidityImpact-ThresholdTable', headers, values);
  }

  updateZoom(animate) {
    this.layout.updatemenus[0].showactive = this.isZoomedAll;

    for (let [i, isZoomed] of this.isZoomed.entries()) {
      this.layout.updatemenus[i + 1].showactive = isZoomed;

      this.zoomOneShapes[i].opacity = isZoomed         ? 0.1 : 0.0;
      this.zoomAllShapes[i].opacity = this.isZoomedAll ? 0.2 : 0.0;
    }

    let buttons = document.querySelectorAll('.updatemenu-button');
    for (let [i, button] of buttons.entries()) {
      if (i == 0) {
        button.classList.toggle('active', this.isZoomedAll);
      } else if (i > 1) {
        button.classList.toggle('active', this.isZoomed[i - 2]);
      }
    }

    Plotly.relayout(this.$refs.plotRef, this.layout);

    let update: any = {
      layout: {
      }
    };

    for (let [i, isZoomed] of this.isZoomed.entries()) {
      let index = this.getPlotlyIndex(i);

      update.layout['xaxis' + index] = { range: this.isZoomedAll || this.isZoomed[i] ? this.rangeX.zoomed.slice() : this.rangeX.full.slice() };
      update.layout['yaxis' + index] = { range: this.isZoomed[i] ? this.rangeAxisY[i].zoomed.slice() : (this.isZoomedAll ? this.rangeY.slice() : this.rangeAxisY[i].full.slice()) };
    }

    if (animate) {
      Plotly.animate(this.$refs.plotRef, update, {
        transition: {
          duration: 500,
          easing: 'cubic-in-out'
        }
      });
    } else {
      for (let [i, isZoomed] of this.isZoomed.entries()) {
        let index = this.getPlotlyIndex(i);

        this.layout['xaxis' + index].range = update.layout['xaxis' + index].range.slice();
        this.layout['yaxis' + index].range = update.layout['yaxis' + index].range.slice();

        this.layout['xaxis' + index].autorange = false;
        this.layout['yaxis' + index].autorange = false;
      }

      Plotly.relayout(this.$refs.plotRef, this.layout);
    }
  }

  mounted() {
    this.redrawPlots();
    window.addEventListener('resize', this.handleResize);

    this.handleResizeDelayed();
  }

  redrawPlots() {
    var stackOnWidth = this.$vuetify.breakpoint.lgAndUp;
    var height = 1200;
    var compareLabelRHs = ['>85%', '<75%', '50%'];
    var compareLabelsX  = [0.5,  0.5,   0.5];
    var compareLabelsY  = [0.28, 0.65,  1.02];
    var compareIndices  = [4,    2,     0];
    var thresholdsX     = [0.0,  0.0,   0.0];
    var titleY          = 0.99;
    var zoomAllButtonX  = 0.125;
    var zoomAllButtonY  = 1.05;
    var zoomButtonX     = [1.0,  1.0,  1.0];
    var zoomButtonY     = [0.31, 0.68, 1.05];
    var theme: any = this.$vuetify.theme;

    if (stackOnWidth) {
      height = 700;
      compareLabelRHs = ['50%', '<75%', '>85%'];
      compareLabelsX  = [0.16, 0.50, 0.84];
      compareLabelsY  = [1.05, 1.05, 1.05];
      compareIndices  = [0,    2,    4];
      thresholdsX     = [0.0, 0.3435,  0.686];
      titleY          = 0.99;
      zoomAllButtonX  = 0.07;
      zoomAllButtonY  = 1.11;
      zoomButtonX     = [0.313, 0.656, 1.0];
      zoomButtonY     = [1.11,  1.11,  1.11];
    }


    var themeColors = [
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7,
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7
    ]

    var data = [];
    this.numDataPoints = 0;
    let numThresholdPoints = [];

    // Calculate all the number of points first, to make it easier to handle later.
    for (let index of compareIndices) {
      let currentNumThresholdPoints = 0;
      for (let board of this.boards) {
        if (!board.visible ||
            !board.hasBoardResults() ||
            board.hasSimulationErrors() ||
            !board.hasSimulationSuccessWithHumidityImpact())
          continue;

        if (index == 0)
          this.numDataPoints++;

        let thresholdPoint = board.thresholdResults[index].weeks;
        if (thresholdPoint >= 0.0 && thresholdPoint <= 104.0)
          currentNumThresholdPoints++;
      }

      numThresholdPoints.push(currentNumThresholdPoints);
    }

    this.layout = {
      title: {
        text: 'Humidity Impact for Stacking Strength',
        y: titleY,
      },
      showlegend: false,
      height: height,
      margin: {
        pad: 3,
      },
      updatemenus: [
        {
          type: 'buttons',
          showactive: false,
          active: 0,
          direction: 'right',
          buttons: [
            {
              name: 'zoomAll',
              label: 'Zoom All',
              method: 'skip',
            },
            {
              name: 'resetAll',
              label: 'Reset All',
              method: 'skip',
            },
          ],
          pad: {
            r: 0,
            t: 0,
          },
          xanchor: 'middle',
          x: zoomAllButtonX,
          yanchor: 'top',
          y: zoomAllButtonY,
        },
      ],
      annotations: [],
      shapes: [],
    }

    this.zoomOneShapes = [];
    this.zoomAllShapes = [];
    this.thresholdAnnotations = [];

    let padding = 0.12;
    if (stackOnWidth)
      padding = 0.03;

    var currentPosition = 0.0;
    let figureWidth = (1 - (compareIndices.length - 1) * padding) / compareIndices.length;
    for (let i = 0; i < compareIndices.length; i++) {
      let index = compareIndices[i];
      let compareLabel = this.rhValueToDescriptive(compareLabelRHs[i]);
      let axisIndex = i + 1;
      let zoomedMinY = Number.MAX_VALUE;
      let zoomedMaxY = Number.MIN_VALUE;
      let thresholdIndex = 0;
      let thresholdVisible = false;
      let traceOpacity = 1.0;

      if (index == this.rhIndexFocused) {
        // Show the threshold value if the threshold text field has focus.
        thresholdVisible = true;
      } else if (this.rhIndexFocused != -1) {
        // Fade every other trace if the threshold text field has focus.
        traceOpacity = 0.2;
      }

      for (let j = 0; j < this.boards.length; j++) {
        let board = this.boards[j];

        if (!board.visible ||
            !board.hasBoardResults() ||
            board.hasSimulationErrors() ||
            !board.hasSimulationSuccessWithHumidityImpact())
          continue;

        const x = this.weeks;
        const y = board.simulationResults[0].stacking_factors_result.RH_results[index].bct_values;

        var trace = {
          x: x,
          y: y,
          xaxis: 'x' + axisIndex,
          yaxis: 'y' + axisIndex,
          opacity: traceOpacity,
          line:{
            color: themeColors[j],
          },
          name: board.name,
        };

        data.push(trace);

        let thresholdPoint = board.thresholdResults[index].weeks;
        let thresholdOpacity = 1.0;

        if (thresholdPoint <= 0.0 || thresholdPoint > 104.0) {
          // Hide the point if it's out of range. It's still created so that every index is correct when hovering.
          thresholdOpacity = 0.0;
          thresholdPoint = 1.0;
        } else {
          thresholdIndex++;
        }

        // The bct value on the intersection with the threshold value. Hidden by default.
        const thresholdAnnotation = {
          xref: 'x' + axisIndex,
          yref: 'y' + axisIndex,
          x: Math.log10(thresholdPoint + 1),
          ax: 15,
          xanchor: 'top',
          y: this.thresholds[index].bct_value,
          ay: -25 - (numThresholdPoints[i] - thresholdIndex)*25,
          yanchor: 'left',
          text: this.weeksToDescriptive(thresholdPoint),
          bgcolor: themeColors[j],
          borderpad: 4,
          font: {
            color: 'white',
          },
          showarrow: true,
          arrowcolor: themeColors[j],
          visible: thresholdVisible,
          opacity: thresholdOpacity,
        };

        this.thresholdAnnotations.push(thresholdAnnotation);
        this.layout.annotations.push(thresholdAnnotation);

        zoomedMinY = Math.min(zoomedMinY, ...y.slice(1));
        zoomedMaxY = Math.max(zoomedMaxY, ...y.slice(1));
      }

      if (data.length === 0)
        return;

      this.rangeAxisY[i].zoomed = [zoomedMinY * 0.97, zoomedMaxY * 1.03];

      this.layout['yaxis' + axisIndex] = {
        hoverformat: '.0f',
        fixedrange: true,
        anchor: 'x' + axisIndex,
        rangemode: 'tozero',
        autorange: true,
        zeroline: false,
      };

      if (i == 0 || !stackOnWidth)
        this.layout['yaxis' + axisIndex].title = 'Stacking Strength (N)<br>&nbsp;';

      if (!stackOnWidth)
        this.layout['yaxis' + axisIndex].domain = [currentPosition, currentPosition + figureWidth];

      this.layout['xaxis' + axisIndex] = {
        fixedrange: true,
        anchor: 'y' + axisIndex,
        ticktext: this.years,
        tickvals: this.weeks,
        type: 'log',
        visible: true,
        showaxeslabels: true,
        showline: true,
      };

      if (stackOnWidth)
        this.layout['xaxis' + axisIndex].domain = [currentPosition, currentPosition + figureWidth];

      // The title above each plot.
      this.layout.annotations.push({
        xref: 'paper',
        yref: 'paper',
        x: compareLabelsX[i],
        xanchor: 'center',
        y: compareLabelsY[i],
        yanchor: 'bottom',
        text: compareLabel,
        showarrow: false,
        hovertext: compareLabelRHs[i],
      });

      this.layout.updatemenus.push({
        type: 'buttons',
        showactive: false,
        active: 0,
        buttons: [
          {
            name: 'zoom' + i,
            label: 'Zoom',
            method: 'skip',
          },
        ],
        pad: {
          r: 0,
          t: 0,
        },
        xanchor: 'right',
        x: zoomButtonX[i],
        yanchor: 'top',
        y: zoomButtonY[i],
      });

      // The box that shows where to zoom a single plot.
      const zoomShape = {
        type: 'rect',
        xref: 'x' + axisIndex,
        yref: 'y' + axisIndex,
        x0: 2 * 0.9,
        y0: zoomedMinY * 0.97,
        x1: 105 * 1.1,
        y1: zoomedMaxY * 1.03,
        fillcolor: '#85C1A6',
        opacity: 0.0,
        line: {
          width: 2,
          color: '#367551',
        },
      };

      this.zoomOneShapes.push(zoomShape);
      this.layout.shapes.push(zoomShape);

      // The lines that shows the threshold.
      this.layout.shapes.push({
        type: 'line',
        xref: 'x' + axisIndex,
        yref: 'y' + axisIndex,
        x0: 1 * 0.8,
        y0: this.thresholds[index].bct_value,
        x1: 105 * 1.2,
        y1: this.thresholds[index].bct_value,
        opacity: 0.8,
        line: {
          width: 2,
          color: theme.error,
          dash: 'dot',
        },
      });

      // The threshold value to the left.
      this.layout.annotations.push({
        xref: 'paper',
        yref: 'y' + axisIndex,
        x: thresholdsX[i],
        xanchor: 'right',
        y: this.thresholds[index].bct_value,
        yanchor: 'center',
        text: this.thresholds[index].bct_value,
        bgcolor: 'white',
        borderpad: 2,
        font: {
          color: theme.error,
        },
        showarrow: false,
      });

      currentPosition += figureWidth + padding;
    }

    let zoomedMinY = Number.MAX_VALUE;
    let zoomedMaxY = Number.MIN_VALUE;

    for (let i = 0; i < compareIndices.length; i++) {
      zoomedMinY = Math.min(zoomedMinY, this.rangeAxisY[i].zoomed[0]);
      zoomedMaxY = Math.max(zoomedMaxY, this.rangeAxisY[i].zoomed[1]);
    }

    for (let i = 0; i < compareIndices.length; i++) {
      const index = this.getPlotlyIndex(i);

      // The box that shows where to zoom all plots.
      const zoomAllShape = {
        type: 'rect',
        xref: 'x' + index,
        yref: 'y' + index,
        x0: 2 * 0.9,
        y0: zoomedMinY,
        x1: 105 * 1.1,
        y1: zoomedMaxY,
        fillcolor: '#d3d3d3',
        opacity: 0.0,
        line: {
          width: 1,
        },
      };

      this.zoomAllShapes.push(zoomAllShape);
      this.layout.shapes.push(zoomAllShape);
    }

    var config = {
      displayModeBar: false,
    };

    Plotly.plot(this.$refs.plotRef, data, this.layout, config);

    this.$refs.plotRef.on('plotly_buttonclicked', e => {
      if (e.button.name === 'zoomAll') {
        this.isZoomedAll = !this.isZoomedAll;
      } else if (e.button.name === 'resetAll') {
        this.isZoomedAll = false;

        for (let [i, isZoomed] of this.isZoomed.entries()) {
          this.isZoomed[i] = false;
        }
      }

      for (let [i, isZoomed] of this.isZoomed.entries()) {
        if (e.button.name === 'zoom' + i) {
          this.isZoomed[i] = !this.isZoomed[i];
        }
      }

      this.updateZoom(true);
    });

    let buttons = document.querySelectorAll('.updatemenu-button');
    for (let [buttonIndex, button] of buttons.entries()) {
      button.addEventListener('mouseenter', (e: any) => {
        e.srcElement.classList.add('hover');

        if (buttonIndex == 0 && !this.isZoomedAll) {
          for (const zoomAllShape of this.zoomAllShapes) {
            zoomAllShape.opacity = 0.2;
          }

          Plotly.relayout(this.$refs.plotRef, this.layout);
        } else if (buttonIndex > 1 && !this.isZoomed[buttonIndex - 2]) {
          this.zoomOneShapes[buttonIndex - 2].opacity = 0.1;
          Plotly.relayout(this.$refs.plotRef, this.layout);
        }
      });

      button.addEventListener('mouseleave', (e: any) => {
        e.srcElement.classList.remove('hover');

        if (buttonIndex == 0 && !this.isZoomedAll) {
          for (const zoomAllShape of this.zoomAllShapes) {
            zoomAllShape.opacity = 0.0;
          }

          Plotly.relayout(this.$refs.plotRef, this.layout);
        } else if (buttonIndex > 1 && !this.isZoomed[buttonIndex - 2]) {
          this.zoomOneShapes[buttonIndex - 2].opacity = 0.0;
          Plotly.relayout(this.$refs.plotRef, this.layout);
        }
      });
    }

    for (let i = 0; i < compareIndices.length; i++) {
      let index = this.getPlotlyIndex(i);
      this.rangeAxisY[i].full = this.layout['yaxis' + index].range;
    }

    this.rangeY = [zoomedMinY, zoomedMaxY];

    this.updateZoom(false);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResizeDelayed() {
    setTimeout(() => {
      this.handleResize();
    }, 200);
  }

  handleResize() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }

  updateThresholds() {
    if (_.isEqual(this.thresholds, this.project.thresholds))
      return;

    const thresholds = _.cloneDeep(this.thresholds);
    let thresholdsWithoutTypenames = [];

    for (let threshold of thresholds) {
      thresholdsWithoutTypenames.push(_.omit(threshold, ['__typename']));
    }

    this.isUpdatingThresholds = true;
    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $thresholds: [ThresholdInput]!) {
          projectUpdateThresholds(id: $id, thresholds: $thresholds) {
            ...ProjectThresholds
          }
        }
        ${PROJECT_THRESHOLDS_FRAGMENT_QUERY}
      `,
      variables: {
        id: this.project.id,
        thresholds: thresholdsWithoutTypenames,
      },
      update: (store, {data: { projectUpdateThresholds }}) => {
        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: PROJECT_THRESHOLDS_FRAGMENT_QUERY,
          data: projectUpdateThresholds
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectUpdateThresholds: {
          __typename: 'Project',
          thresholds: thresholds
        },
      },
    }).then(() => {
      this.isUpdatingThresholds = false;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HumidityPlotWrapperObject.vue